import LabelField from '@app/components/atoms/LabelField/LabelField'
import { VOUCHER_TYPE } from '@app/constant/VoucherTypeConstant'
import Grid from '@mui/material/Grid'
import MenuItem from '@mui/material/MenuItem'
import TextField from '@mui/material/TextField'
import { useState } from 'react'
import { Controller } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

const CodeSection = ({ register, errors, control, setValue, getValues, voucherType }) => {
  const { t } = useTranslation()
  const [typeVoucher, setTypeVoucher] = useState('standard')

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <LabelField title={t('VOUCHER.TYPE_VOUCHER')}>
          <Controller
            control={control}
            name="type"
            render={() => (
              <TextField
                fullWidth
                select
                defaultChecked="standard"
                InputLabelProps={{
                  shrink: true,
                }}
                name="type"
                size="small"
                value={getValues('type')}
                variant="outlined"
                onChange={(e) => {
                  if ('standard' === e.target.value) {
                    setValue('limit_min', 0)
                    setValue('limit_max', 0)
                  }
                  setValue('type', e.target.value)
                  setTypeVoucher(e.target.value)
                }}
              >
                {voucherType.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {t(option.name)}
                  </MenuItem>
                ))}
              </TextField>
            )}
          />
        </LabelField>
      </Grid>

      <Grid item sx={{ display: VOUCHER_TYPE.STANDARD === typeVoucher ? 'none' : 'block' }} xs={12}>
        <LabelField title={t('VOUCHER.MIN')}>
          <Controller
            control={control}
            name="limit_min"
            render={({ field }) => (
              <TextField
                {...field}
                {...register('limit_min')}
                fullWidth
                error={!!errors.limit_min}
                helperText={errors.limit_min?.message}
                name="limit_min"
                size="small"
                type="number"
                value={getValues('limit_min')}
                variant="outlined"
              />
            )}
          />
        </LabelField>
      </Grid>

      <Grid item sx={{ display: VOUCHER_TYPE.STANDARD === typeVoucher ? 'none' : 'block' }} xs={12}>
        <LabelField title={t('VOUCHER.MAX')}>
          <Controller
            control={control}
            name="limit_max"
            render={() => (
              <TextField
                {...register('limit_max')}
                fullWidth
                error={!!errors.limit_max}
                helperText={errors.limit_max?.message}
                name="limit_max"
                size="small"
                type="number"
                value={getValues('limit_max')}
                variant="outlined"
              />
            )}
          />
        </LabelField>
      </Grid>
    </Grid>
  )
}
export default CodeSection
